module.exports = '<svg width="34" height="32" viewBox="0 0 34 32"><path d="M31.998 28.236h-1.882V15.06h1.882c.811 0 1.528-.518 1.784-1.287a1.879 1.879 0 0 0-.657-2.101L18.067.379a1.874 1.874 0 0 0-2.257 0L.752 11.672a1.88 1.88 0 0 0-.655 2.101c.256.77.973 1.287 1.784 1.287h1.882v13.176H1.881c-1.041 0-1.882.841-1.882 1.882S.84 32 1.881 32h30.116c1.041 0 1.882-.841 1.882-1.882s-.841-1.882-1.882-1.882zm-24.469 0V15.06h3.764v13.176H7.529zm7.529 0V15.06h3.764v13.176h-3.764zm7.529 0V15.06h3.764v13.176h-3.764z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/government-1.js
// module id = 1162
// module chunks = 14